import React, { Dispatch, useEffect, useState } from 'react';

import {DragSourceMonitor, useDrag, useDrop} from 'react-dnd';
import { ItemTypes } from '../../../types/ItemTypes';

import classes from './dndUserItem.module.scss';
import { ReactComponent as EyeOpen } from '../../../assets/images/eye.svg';
import {Staff, Subdivision} from '../../../types/subdivision';
import { useStaff, useSubdivivsion } from '../../../hooks/entityHooks';

type ChangeOptions = {
  a: string;
  b: string;
  newParent: number;
  id: number;
  isStuff: boolean;
};
type logsInfo = {
  id?: number;
  type?: number;
  handleGetTree(): void;
};
type HandleGetTree = {
  handleGetTree(): void;
};
type UpdateEntity = {
  id: number;
  getTree(): void;
  type: number;
};
type props = {
  photo: string;
  // name: string;
  // org: string;
  Eye: any;
  setEmployeeInfoShow: Dispatch<boolean>;
  setOrgInfoShow: Dispatch<boolean>;
  handleSetStaff({ id, type, handleGetTree }: logsInfo): void;
  previousName: string;
  handleChangeOptions({ a, b }: ChangeOptions): void;
  handleChangeIsKarmaUser(
    id: number,
    type: number,
    value: boolean,
    handleGetTree: () => void,
  ): void;
  handleGetTree(): void;
  item: any;
  handleSetEntityUpdateArray({ id, getTree, type }: UpdateEntity): void;
} & Staff;
export const UserItem = ({
  photo,
  Eye,
  setEmployeeInfoShow,
  setOrgInfoShow,
  org,
  lastname,
  middlename,
  firstname,
  handleSetStaff,
  id,
  isKarmaUser,
  handleChangeIsKarmaUser,
  previousName,
  handleChangeOptions,
  handleGetTree,
  item,
  handleSetEntityUpdateArray,
}: props) => {
  const [{ opacity }, drag, preview] = useDrag({
    item: {
      name: `${lastname} ${firstname} ${middlename}`,
      type: ItemTypes.SUBDIVISION,
    },
    end: (item: { name: string } | undefined, monitor: DragSourceMonitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        handleChangeOptions({ a: previousName, b: dropResult.name, newParent: dropResult.id, id: id, isStuff: true });
      }
    },
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.4 : 1,
    }),
  });

  handleSetEntityUpdateArray({ id, getTree: handleGetTree, type: 3 });

  const { getTree } = useSubdivivsion();

  return (
    <div
      ref={drag}
      className={classes.cardBody}
      onClick={() => {
        setEmployeeInfoShow(true);
        setOrgInfoShow(false);
        handleSetStaff({ type: 3, id, handleGetTree });
      }}
    >
      <div className={classes.photoCard}>
        <img src={photo} alt="" />
        <div>
          <div className={classes.photoCard__name}>
            {lastname} {firstname} {middlename}
          </div>
          <div className={classes.photoCard__org}>{org.orgShortName}</div>
        </div>
      </div>

      <span style={{ width: 24 }}>
        {isKarmaUser ? (
          <EyeOpen
            onClick={async () => {
              if (handleGetTree) {
                await handleChangeIsKarmaUser(
                  id,
                  3,
                  !isKarmaUser,
                  handleGetTree,
                );
                await getTree(item.id);
              }
            }}
          />
        ) : (
          <Eye
            onClick={async () => {
              if (handleGetTree) {
                await handleChangeIsKarmaUser(
                  id,
                  3,
                  !isKarmaUser,
                  handleGetTree,
                );
                await getTree(item.id);
              }
            }}
          />
        )}
      </span>
    </div>
  );
};
